// Constants for different requests for current reducer
export default {
  tsBySite: 'TS_BY_SITE',
};
